import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { IconButton, Switch } from "@mui/material";
import React from "react";

import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import SWR_KEYS from "@/constants/swr-keys";
import useUpdatePaymentType from "@/hooks/requests/t2Pay/use-update-payment-type";
import usePopOver from "@/hooks/use-popover";
import useMutate from "@/hooks/use-mutate";
import { PaymentType } from "@/interfaces/payment-type.interface";
import { PaymentTypeMessages } from "@/messages/platforms/talk2PayHome/payment-type.messages";

import PaymentTypePopover from "../paymentTypePopover";

interface Props {
  item: PaymentType;
  index: number;
  messages: PaymentTypeMessages;
  onRemove: (item: PaymentType) => void;
  onEdit: (item: PaymentType) => void;
}

const formatPercent = (n: number) =>
  `${Number(n ?? 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;

const formatCurrency = (n: number) =>
  `R$ ${Number(n ?? 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function PaymentTypeTableRow({ messages, item, index, onRemove, onEdit }: Props) {
  const { openPopover, anchorEl, closePopover, isOpen, selected } = usePopOver<PaymentType>();
  const { update, isLoading } = useUpdatePaymentType();
  const { mutate } = useMutate();

  const handleToggleActive = async () => {
    await update({
      _id: item.id,
      formData: {
        active: !item.active,
        discountApplied: item.discountApplied,
        discountOver: item.discountOver,
        maxInstallmentCount: item.maxInstallmentCount ?? 1,
        minInstallmentAmount: item.minInstallmentAmount ?? 0,
        monthlyInterestRates: item.monthlyInterestRates || "{}",
      },
      successMessage: messages.updateSuccess,
      errorMessage: messages.updateError,
      onSuccess: () => mutate(SWR_KEYS.getPaymentTypes),
    });
  };

  return (
    <TableRow index={index}>
      <TableCell>{item.paymentTypeName}</TableCell>
      <TableCell>{formatPercent(item.discountApplied)}</TableCell>
      <TableCell>{formatCurrency(item.discountOver)}</TableCell>
      <TableCell>
        <Switch
          checked={item.active}
          disabled={isLoading}
          onClick={(e) => {
            e.stopPropagation();
            handleToggleActive();
          }}
        />
      </TableCell>
      <TableCell>
        <IconButton onClick={(e) => openPopover(e, item)}>
          <MoreHorizIcon />
        </IconButton>
        {selected && (
          <PaymentTypePopover
            isOpen={isOpen}
            anchorEl={anchorEl}
            onClose={closePopover}
            messages={messages}
            selected={selected}
            onRemove={onRemove}
            onEdit={onEdit}
          />
        )}
      </TableCell>
    </TableRow>
  );
}
